<template>
    <div>
        <div v-if="row.campaign">
            <p class="mb-0 font-weight-bold">#{{ row.campaign.id }}</p>
            <p class="mb-0">{{ row.campaign.name }}</p>
            <p v-if="showIncomingNumber" class="mb-0">{{ incomingNumberDisplay }}</p>
        </div>
        <span v-else>-</span>
    </div>
</template>

<script>
export default {
    name: 'LineColumn',
    props: {
        row: {
            type: Object,
            required: true,
        },
        showIncomingNumber: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        incomingNumberDisplay() {
            if (this.showIncomingNumber && this.row.phone_number) {
                return this.$options.filters.fixPhone(this.row.phone_number, 'INTERNATIONAL')
            }
            return null
        }
    }
}
</script>
